// Globals
import { useState } from 'react';

// Modules
import { useSettings } from '@/modules/Settings';

// Components
import { StyledSender } from './SenderContainerStyles';
import { SendIcon } from '@/icons';

// Helpers
import { DEFAULT_MAIN_COLOR } from '@/constants/common';

type TChatContainerWrapperProps = {
  disabled?: boolean;
  onSend: (message: string) => void;
};

export const SenderContainer = ({ onSend, disabled }: TChatContainerWrapperProps) => {
  const [value, setValue] = useState('');
  const { settings } = useSettings();
  const mainColor = settings?.main_color ?? DEFAULT_MAIN_COLOR;

  const handleSend = (value: string) => {
    if (disabled) return;
    const message = value.trim();
    if (!message) return;
    onSend(message);
    setValue('');
  };

  return (
    <StyledSender
      onSubmit={handleSend}
      value={value}
      onChange={setValue}
      $primary={mainColor}
      placeholder="Message..."
      autoSize={{ minRows: 1, maxRows: 5 }}
      actions={(_, info) => {
        const { SendButton } = info.components;
        return <SendButton icon={<SendIcon />} disabled={disabled} />;
      }}
    />
  );
};
